export default __webpack_public_path__ + "static/media/VWebLogo.d9d99437.png";